import React, {useState, useRef} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from '../../components/recordedData/RecordedDataComponent';
import Cookies from "js-cookie";

const SupervisorIndexRecordedData = () => {
    const role = Cookies.get("role");
  return (
        <>
        <div className="recorded-data-container">
                <Sidebar role="supervisor"/>
            <div className="main-content">
                <Header/>
                <RecordedDataComponent role="coordinator-index" title="RECORDED INDEXED DATA"/>
            </div>
        </div>
        </>
      )
}

export default SupervisorIndexRecordedData